import { RESTClient, RESTClientMock } from '@api/client';
import { PaginatedResponse } from '@dynamika-shared/types/general';
import { API_URL, SERVICE_URL } from '@api/apiDictionary';
import { USE_API_MOCKS } from '../env';
import {
  SponsorOverviewFetchAction,
  SponsorOverviewItem,
  SponsorOverviewSummaryResponse,
} from '@restore/sponsorOverview/sponsorOverview.types';
import { StatisticsParams } from 'src/store-redux/sponsorStatistics';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchSponsorOverview = async (
  clinicalTrialId: string,
  type: string,
  filters: SponsorOverviewFetchAction['payload']['filters']
) => {
  return api.get<PaginatedResponse<SponsorOverviewItem>>(
    API_URL.dashboardPage.replace(':type', type),
    {
      baseURL: SERVICE_URL.auditLogsService,
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      params: {
        page: filters?.page ? filters?.page - 1 : 0,
        size: filters?.size ?? 10,
        ...(filters?.sort && { sort: filters.sort }),
        ...(filters?.search && { search: filters.search }),
        ...(filters?.siteId && { siteId: filters.siteId }),
        ...(filters?.visitId && { visitDefinitionId: filters.visitId }),
        ...(filters?.unscheduled && { unscheduledVisit: filters.unscheduled }),
      },
      id: 'sponsor-overview',
    }
  );
};

export const fetchSponsorOverviewSummary = async (
  clinicalTrialId: string,
  type: string
) => {
  return api.get<SponsorOverviewSummaryResponse>(
    API_URL.dashboardSummary.replace(':type', type),
    {
      baseURL: SERVICE_URL.auditLogsService,
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      params: {},
      id: 'sponsor-overview-summary',
    }
  );
};

export const fetchSponsorStatistics = async <T>(
  clinicalTrialId: string,
  type: string,
  params: StatisticsParams
) => {
  return api.get<PaginatedResponse<T>>(
    API_URL.dashboardEligibility.replace(':type', type),
    {
      baseURL: SERVICE_URL.auditLogsService,
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      params,
      id: 'sponsor-statistics',
    }
  );
};
